import React, { useState } from "react";

const head = {
  "heading": "Alumni Network Benefits",
  "description": "Are you ready to take your student experience to the next level? Introducing the Alumni Connect App – your passport to a vibrant community of alumni and current students, all in one powerful platform.."
}


const Database = [
  {
    "name": "Networking Opportunities",
    "icon": "fas fa-network-wired",
    "image": "./assets/alumni_networking.png",
    "description": "Connect with alumni across diverse industries for mentorship, internships, job referrals, or partnerships. Expand your network and gain valuable career insights."
  },
  {
    "name": "Career Guidance",
    "icon": "fas fa-user-tie",
    "image": "./assets/careerguidance.png",
    "description": "Access career insights from experienced alumni. Discover industry trends and job market tips. Receive personalized guidance on resume building and interview preparation tailored to your field."
  },
  {
    "name": "Exclusive Events",
    "icon": "fas fa-calendar-alt",
    "image": "./assets/alumni_events&reunion.png",
    "description": "Access diverse events like career fairs, panels, and mixers. Engage in workshops with alumni. Network for opportunities."
  },
  {
    "name": "Personalized Groups",
    "icon": "fas fa-users",
    "image": "./assets/enhanced_alumni_betworking.webp",
    "description": "Discover tailored groups based on your interests, career goals, or academic focus. Engage, share, and collaborate with peers and alumni."
  },
  {
    "name": "Stay Updated",
    "icon": "fas fa-newspaper",
    "image": "./assets/stayupdated.webp",
    "description": "Stay informed with real-time updates from your alma mater and alumni network. Keep connected post-graduation with news on campus events and achievements."
  }

];

const MultitabComp = () => {
  const [feature, setFeature] = useState("Networking Opportunities");
  return (
    <div className="multitab_comp" id="cloud">
      <div className="container">
        <div className="comp_header">
          <h1>{head?.heading}</h1>
          <p>
           {head?.description}
          </p>
        </div>
        <div className="comp_data">
          <div className="first">
            {Database?.map((data, idx) => (
              <div
                className={feature == data?.name ? "card active_card" : "card"}
                onClick={() => setFeature(data?.name)}
              >
                <div className="icon">
                  <i class={data?.icon}></i>
                </div>
                <div className="details">
                  <h4>{data?.name}</h4>
                  <p>{data?.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="second">
            <img
              width={600}
              height={600}
              src={Database?.find((dt) => dt?.name == feature)?.image}
              alt=""
            />
            {/* <div className="img_containers">
              <img src="/assets/pic-3.png" alt="" />
            </div>
            <div className="img_containers">
              <img src="/assets/pic-4.png" alt="" />
            </div>
            <div className="img_containers">
              <img src="/assets/pic-1.png" alt="" />
            </div> */}
            {/* <div className="img_containers">
              <img src="/assets/pic-2.png" alt="" />
            </div> */}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultitabComp;
